/* eslint-disable camelcase */
import React from 'react'
import axios from 'axios'
import moment from 'moment'
import { connect } from 'react-redux'
import { clamp, get } from 'lodash'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { updateCart } from '~redux/shop'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Button from '~components/ui/Button'
import StockLevelPrompt from '~components/shop/StockLevelPrompt'
// import { Prompt } from 'react-router-dom'
import Sprite from '~components/Sprite'
import AnimateHeight from 'react-animate-height'
import Message from '~components/ui/Message'
import { hasCallback } from '~helpers/main'

class ProductMatrix extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      busy: false,
      focussed: null,
      selected: {},
      stockLevels: {},
      acceptance: false,
      exceededStockItems: [],
      activeRow: null,
      activeCol: null,
      navigationBlocked: false,
      modal: false,
      messageText: '',
      messageType: ''
    }

    this.submit = this.submit.bind(this)
  }

  componentDidMount () {
    this.resetSelected()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.sizingMode !== this.props.sizingMode) {
      this.setState({ focussed: null })
    }
  }

  resetSelected () {
    this.setState({
      selected: this.props.product.variants.reduce((carry, variant) => {
        carry[variant.id] = 0

        return carry
      }, {})
    })
  }

  handleQtyChange (id, qty, callback = null) {
    const variant = this.props.product.variants.find(v => v.id === id)
    const cartItem = this.props.cartItems.find(i => i.variant_id === id)
    const stockImmediateQty = variant.warehouse_stock[this.props.warehouse]
    const stockOtsQty = variant.warehouse_stock_ots[this.props.warehouse]
    const stockDueDates = JSON.parse(this.props.product.metafields.due_date)
    const size = variant.option_values.find(option => option.option_display_name === 'Size')
    const basketQty = this.getBasketQuantityForVariant(id)

    qty = clamp(qty, 0, stockOtsQty)

    if (cartItem) {
      qty -= cartItem.quantity
    }

    this.setState({
      navigationBlocked: true,
      acceptance: false,
      stockLevels: {
        ...this.state.stockLevels,
        [id]: {
          id,
          name: this.props.product.name,
          size: size.label,
          qty: (qty + basketQty),
          stock: clamp(stockImmediateQty, 0, Math.abs(stockImmediateQty)),
          stockDueDate: stockDueDates[id],
          exceeded: (qty + basketQty) > stockImmediateQty
        }
      },
      selected: {
        ...this.state.selected,
        [id]: qty
      }
    }, () => {
      this.setState({
        exceededStockItems: this.getCartItemsWhichExceedStock()
      }, () => {
        hasCallback(callback) && callback.call(this)
      })
    })
  }

  isStockLevelExceededForSize (id) {
    const notice = this.state.stockLevels
    return notice[id] !== undefined && notice[id]?.exceeded
  }

  doCartItemsExceedStock () {
    const { exceededStockItems } = this.state
    return exceededStockItems && exceededStockItems.length > 0
  }

  getCartItemsWhichExceedStock () {
    const { stockLevels } = this.state
    const cartItems = this.getCartItems()

    return Object.keys(cartItems).reduce((items, id) => {
      const exceedsStock = stockLevels[id]?.exceeded
      exceedsStock && items.push(stockLevels[id])
      return items
    }, [])
  }

  clearForwardOrderStockItem (id) {
    const { stockLevels } = this.state
    const stockItem = stockLevels[id]
    const updatedQty = stockItem.stock

    this.handleQtyChange(id, updatedQty, () => {
      this.setState({
        modal: this.shouldShowStockPrompt()
      })
    })
  }

  getBasketQuantityForVariant (id) {
    const { cartItems } = this.props
    const variant = cartItems.find(i => i.variant_id === id)

    if (variant) {
      return variant.quantity
    }

    return 0
  }

  inputValue (variantId) {
    const cartItem = this.props.cartItems.find(i => i.variant_id === variantId)
    const selected = this.state.selected[variantId] || 0

    if (cartItem) {
      return selected + cartItem.quantity
    }

    return selected
  }

  getStockBgColour (immediateStock, otsStock, exceeded = false) {
    if (exceeded || (immediateStock < 1) || (otsStock < 1)) {
      return 'light-red'
    }

    if (immediateStock <= 9) {
      return 'light-yellow'
    }

    return 'light-green'
    // return 'white'
  }

  isMobile () {
    return this.props.mobile || false
  }

  getSize (label) {
    if (label) {
      return label.replace(/\D/g, '')
    }

    return null
  }

  getCupSize (label) {
    if (label) {
      return label.replace(/[0-9]/g, '')
    }

    return null
  }

  getCartItems () {
    const { selected } = this.state

    return Object.keys(selected).reduce((carry, key) => {
      if (selected[key]) {
        carry[key] = selected[key]
      }

      return carry
    }, {})
  }

  setMessage (type, message) {
    this.setState({
      messageType: type,
      messageText: message
    })

    setTimeout(() => {
      this.setState({
        messageType: ''
      })
    }, 5000)
  }

  shouldShowStockPrompt () {
    const { exceededStockItems, acceptance } = this.state

    if (exceededStockItems && exceededStockItems.length > 0 && !acceptance) {
      return true
    }

    return false
  }

  confirmAcceptanceOfExceededStockLevels () {
    this.setState({
      acceptance: true,
      modal: false
    }, () => this.submit())
  }

  confirm () {
    this.setState({
      modal: false
    }, () => this.submit())
  }

  submit () {
    const showPrompt = this.shouldShowStockPrompt()

    this.setState({
      modal: showPrompt
    })

    if (this.state.busy || showPrompt) {
      return
    }

    const variants = this.getCartItems()

    if (Object.keys(variants).length < 1) {
      return
    }

    this.setState({ busy: true })

    axios.post(`/api/cart/add/${this.props.product.id}`, {
      variants,
      _method: 'PUT'
    }).then(response => {
      this.resetSelected()

      this.props.updateCart(response.data)

      this.setMessage('success', 'Cart updated')
    }).finally(() => {
      this.setState({
        busy: false,
        navigationBlocked: false
      })
    })
  }

  mappedSize (label, type) {
    if (type === 'brief') {
      const map = this.props.sizeMap[type].find(s => parseInt(s.gb) === parseInt(label))

      if (map) {
        return map[this.props.sizingMode] || label
      }

      return label
    }

    const isCup = /[a-z]/i.test(label)

    if (isCup) {
      const map = this.props.sizeMap[type].cups.find(s => {
        return s.gb.toLowerCase() === label.toLowerCase()
      })

      if (map) {
        return map[this.props.sizingMode] || label
      }

      return label
    }

    const map = this.props.sizeMap[type].bands.find(s => parseInt(s.gb) === parseInt(label))

    if (map) {
      return map[this.props.sizingMode] || label
    }

    return label
  }

  toggleInfo () {
    const info = this.state.info

    this.setState(() => {
      return { info: !info }
    })
  }

  getTileSizes (count = 0) {
    const largeGrid = count > 14
    return largeGrid ? 'w-13 p-3' : 'w-16 p-3'
  }

  sizeIsAvailable (size) {
    if (!size || size.variant.purchasing_disabled) {
      return false
    }

    const { warehouse_stock, warehouse_stock_ots } = size.variant
    return warehouse_stock[this.props.warehouse] >= 1 || warehouse_stock_ots[this.props.warehouse] >= 1
  }

  renderTable (type, sizes, rows) {
    let totalQty = 0
    const tileCss = this.getTileSizes(sizes.length)

    return (
      <>
        {this.state.messageText &&
          <Message
            messageType={this.state.messageType}
            messageText={this.state.messageText}
          />}
        {/* <Prompt
          when={this.state.navigationBlocked}
          message='You have unsaved changes, are you sure you want to leave?'
        /> */}

        <table className={classNames('w-full h-full overflow-hidden', { 'border-coral border': !this.isMobile() })}>
          <thead>
            <tr>
              <th className={classNames('border-coral font-light p-2', { 'border-t h-12 text-xxs': this.isMobile() }, { 'h-16 border-b border-r': !this.isMobile() })}>
                Size
              </th>

              {sizes.map((size, index) => (
                <th
                  tw-content-after=""
                  key={size}
                  className={classNames(
                    'border-coral font-light uppercase p-2',
                    'relative after:bg-coral after:w-full after:top-0 after:left-0 after:right-0 after:block after:absolute',
                    { 'content-after': index === this.state.activeCol },
                    { 'border-t h-12 after:h-1': this.isMobile() },
                    { 'h-16 border-b after:h-2': !this.isMobile() }
                  )}
                >
                  {this.mappedSize(size, type)}
                </th>
              ))}

              <th className={classNames('border-coral font-light p-2', { 'border-t h-12': this.isMobile() }, { 'h-16 border-b border-l': !this.isMobile() })}>
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => {
              let rowQty = 0

              return (
                <tr
                  className="hover:bg-lightGrey"
                  key={row.label}
                  onMouseEnter={(e) => this.setState({ activeRow: row.label })}
                >
                  <td
                    tw-content-after=""
                    className={classNames(
                      'border-coral font-light text-center px-1 py-2',
                      'relative after:bg-coral after:h-full after:top-0 after:bottom-0 after:left-0 after:block after:absolute',
                      { 'after:w-1': this.isMobile() },
                      { 'w-16 border-r after:w-2': !this.isMobile() },
                      { 'content-after': row.label === this.state.activeRow }
                    )}
                  >
                    {this.mappedSize(row.label, type)}
                  </td>

                  {row.sizes.map((size, sizeIndex) => {
                    if (!this.sizeIsAvailable(size)) {
                      const tooltip = size && size.variant.due_date ? `Available to order from ${moment(size.variant.due_date).format('DD/MM/YYYY')}` : null

                      return (
                        <td
                          data-variant-id={size?.variant?.id}
                          tw-content-hover-after=""
                          key={`${row.label}_${sizeIndex}`}
                          onMouseEnter={(e) => this.setState({ activeCol: sizeIndex })}
                          className={classNames(
                            'text-center px-1 py-2',
                            'relative content-hover-after after:bg-lightGrey after:absolute after:-z-1 after:w-full after:left-0 after:h-screenY after:-top-screen50Y'
                          )}
                        >
                          <span className={classNames('rounded flex items-center justify-center mx-auto', 'bg-white} border-dashed border-2 border-grey', { 'w-14 p-2': this.isMobile() }, { [tileCss]: !this.isMobile() })} data-tip={tooltip} aria-label="Unavailable">
                            <span className="block w-4 h-4 fill-grey" aria-hidden="true">
                              <Sprite name="cross" />
                            </span>
                          </span>
                        </td>
                      )
                    }

                    const value = this.inputValue(size.variant.id)

                    rowQty += value
                    totalQty += value

                    const stockImmediateQty = get(size.variant.warehouse_stock, this.props.warehouse, 0)
                    const stockOtsQty = get(size.variant.warehouse_stock_ots, this.props.warehouse, 0)

                    const stockBackorderQty = stockImmediateQty > 0
                      ? stockOtsQty - stockImmediateQty
                      : stockOtsQty + stockImmediateQty

                    const exceeded = this.isStockLevelExceededForSize(size.variant.id)
                    const colour = this.getStockBgColour(stockImmediateQty, stockOtsQty, exceeded)
                    const rowBackorderQty = Math.abs(rowQty - stockImmediateQty)
                    const tooltip = {}
                    tooltip[size.variant.id] = this.isStockLevelExceededForSize(size.variant.id) ? `${rowBackorderQty} Currently out of stock, expected arrival date ${moment(size.variant.due_date).format('DD/MM/YYYY')}` : ''

                    return (
                      <td
                        data-variant-id={size.variant.id}
                        data-variant-sku={size.variant.sku}
                        tw-content-hover-after=""
                        key={size.label}
                        onMouseEnter={(e) => this.setState({ activeCol: sizeIndex })}
                        className={classNames(
                          'text-center px-1 py-2',
                          'relative content-hover-after after:bg-lightGrey after:absolute after:-z-1 after:w-full after:left-0 after:h-screenY after:-top-screen50Y'
                        )}
                        data-tip={tooltip[size.variant.id]}
                        data-for="stockDueIn"
                      >
                        <input
                          type="number"
                          min="0"
                          autoComplete="off"
                          className={classNames(
                            'rounded appearance-none transition-shadow duration-150 ease-in-out outline-none',
                            `bg-${colour} hover:shadow-${colour}-xs focus:shadow-${colour}-sm`,
                            { [`shadow-${colour}-sm`]: this.state.selected[size.variant.id] },
                            { 'text-white': colour === 'light-red' },
                            { 'text-charcoal': colour !== 'light-red' },
                            { 'w-14 p-2': this.isMobile() },
                            { [tileCss]: !this.isMobile() }
                          )}
                          value={value}
                          onChange={e => this.handleQtyChange(size.variant.id, parseInt(e.target.value))}
                          onFocus={() => {
                            const convertedSize = this.mappedSize(this.getSize(size.label), type)
                            const cupSizeLabel = this.mappedSize(this.getCupSize(size.label).trim(), type)
                            const convertedCupSize = cupSizeLabel ? cupSizeLabel.toUpperCase() : null

                            this.setState({
                              focussed: {
                                size: convertedSize,
                                cup: convertedCupSize,
                                sku: size.variant.sku
                              }
                            })
                          }}
                        />
                      </td>
                    )
                  })}

                  <td className={classNames('px-4 text-center py-2 font-light', { 'w-16 border-coral border-l': !this.isMobile() })}>
                    {rowQty}
                  </td>
                </tr>
              )
            })}
          </tbody>

          {!this.isMobile() && (
          <tfoot>
            <tr className="bg-white">
              <td className="h-16 p-4 border-t xl:p-6 border-coral" colSpan={sizes.length + 1}>
                {this.state.focussed && (
                  <div className="flex items-center -mx-2 -my-2 xl:-mx-3">
                    <div className="flex-grow-0 flex-shrink-0 px-2 my-2 xl:px-3">
                      <span className="block">
                        Size
                      </span>

                      <span className="block text-sm xl:text-md">
                        {this.state.focussed.size}
                      </span>
                    </div>

                    {this.getCupSize(this.state.focussed.cup) && (
                      <div className="flex-grow-0 flex-shrink-0 px-2 my-2 xl:px-3">
                        <span className="block">
                          Cup
                        </span>

                        <span className="block text-sm xl:text-md">
                          {this.getCupSize(this.state.focussed.cup)}
                        </span>
                      </div>
                    )}

                    <div className="px-2 my-2 mr-auto xl:px-3">
                      <span className="block">
                        <strong>
                          Sku
                        </strong>
                        {' '}
                        -
                        {' '}
                        {this.state.focussed.sku}
                      </span>
                    </div>

                    <div className="flex-grow-0 flex-shrink-0 px-2 my-2 xl:px-3">
                      <Button
                        type="button"
                        onClick={this.submit}
                        disabled={this.state.busy}
                        busy={this.state.busy}
                      >
                        Update Basket
                      </Button>
                    </div>
                  </div>
                )}
              </td>

              <th className="h-16 py-4 border-t border-coral">
                {totalQty}
              </th>
            </tr>
          </tfoot>
          )}
        </table>

        {this.isMobile() && this.state.focussed && (
          <div className="fixed bottom-0 left-0 right-0 z-10 w-full p-4 transition-transform duration-150 ease-in-out transform bg-white border-t border-coral">
            <div className="flex justify-between w-full md:items-center">

              <div className="flex flex-wrap -mx-2 -my-1">
                <div className="flex items-center px-2 my-1">
                  <span className="block mr-4 text-xxs">
                    Size
                  </span>

                  <span className="block text-md">
                    {this.getSize(this.state.focussed.size)}
                  </span>
                </div>

                {this.getCupSize(this.state.focussed.cup) && (
                  <div className="flex items-center px-2 my-1">
                    <span className="block mr-4 text-xxs">
                      Cup
                    </span>

                    <span className="block text-sm">
                      {this.getCupSize(this.state.focussed.cup)}
                    </span>
                  </div>
                )}

                <div className="flex items-center px-2 my-1">
                  <span className="block mr-4 text-xxs">
                    SKU
                  </span>

                  <span className="block text-sm">
                    {this.state.focussed.sku}
                  </span>
                </div>
              </div>

              <div className="flex-grow-0 flex-shrink-0 my-1 ml-auto">
                <button type="button" className="inline-flex items-center" aria-label={`${this.state.info ? 'Hide' : 'Show'} info`} onClick={() => this.toggleInfo()}>
                  <span className="block w-4 h-4 mr-2" aria-hidden="true">
                    <Sprite name="info" />
                  </span>

                  {`${this.state.info ? 'Hide' : 'Show'} info`}
                </button>
              </div>
            </div>

            <AnimateHeight duration={300} height={this.state.info ? 'auto' : 0}>
              <span className="block w-full mt-4">
                {this.props.product.description}
              </span>
            </AnimateHeight>

            <div className="flex items-center justify-between w-full h-12 mt-4">
              <Button
                type="button"
                onClick={this.submit}
                disabled={this.state.busy}
                busy={this.state.busy}
              >
                Update Basket
              </Button>
            </div>
          </div>
        )}

        {!this.isMobile() && (
          <>
            <ReactTooltip
              effect="solid"
              backgroundColor="#000000"
              className="tooltip"
              id="stockDueIn"
              getContent={(content) => content}
            />

            <ReactTooltip
              effect="solid"
              backgroundColor="#000000"
              className="tooltip"
              id="availableFrom"
            />
          </>
        )}

        {this.state.modal && (
          <StockLevelPrompt
            title="Quantity exceeds immediately available stock levels"
            text="Part of your order will be placed on back order. Please review and confirm."
            cartItems={this.getCartItemsWhichExceedStock()}
            onConfirm={() => this.confirmAcceptanceOfExceededStockLevels()}
            onCancel={() => this.setState({ modal: false })}
            onClose={() => this.setState({ modal: false })}
            onClearForwardOrderItem={(id) => {
              this.clearForwardOrderStockItem(id)
              this.setState({ modal: this.shouldShowStockPrompt() })
            }}
          />
        )}
      </>
    )
  }

  render () {
    const sizes = this.props.product.variants.map(variant => {
      const sizeOption = variant.option_values.find(option => option.option_display_name === 'Size')

      return {
        variant,
        label: sizeOption.label
      }
    })

    sizes.sort((a, b) => {
      const aLabel = parseInt(a.label)
      const bLabel = parseInt(b.label)

      if (aLabel < bLabel) {
        return -1
      }

      if (aLabel > bLabel) {
        return 1
      }

      return 0
    })

    const isBra = /\d+\s*[a-z]+/i.test(sizes[0].label)

    if (!isBra) {
      return this.renderTable('brief', sizes.map(s => s.label), [{
        label: '',
        sizes
      }])
    }

    const bands = []
    const cups = []

    sizes.forEach(size => {
      const parts = /^(\d+)\s*([a-z]+)$/i.exec(size.label)
      const band = parseInt(parts[1])
      const cup = parts[2]

      if (bands.indexOf(band) === -1) {
        bands.push(band)
      }

      if (cups.indexOf(cup) === -1) {
        cups.push(cup)
      }
    })

    bands.sort()
    cups.sort()

    return this.renderTable('bra', cups, bands.map(band => {
      return {
        label: band,
        sizes: cups.map(cup => {
          return sizes.find(size => {
            const parts = /^(\d+)\s*([a-z]+)$/i.exec(size.label)
            const sizeBand = parseInt(parts[1])
            const sizeCup = parts[2]

            return band === sizeBand && cup === sizeCup
          })
        })
      }
    }))
  }
}

ProductMatrix.propTypes = {
  product: PropTypes.object,
  updateCart: PropTypes.func,
  mobile: PropTypes.bool,
  sizeMap: PropTypes.object,
  sizingMode: PropTypes.string,
  warehouse: PropTypes.string,
  cartItems: PropTypes.array,
  navigationBlocked: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  let cartItems = []

  if (state.shop.cart) {
    cartItems = state.shop.cart.line_items.physical_items.filter(i => i.product_id === ownProps.product.id)
  }

  return {
    ...ownProps,
    warehouse: state.auth.account.stockist.office_number,
    sizeMap: state.shop.sizeMap,
    sizingMode: state.shop.sizingMode,
    cartItems
  }
}

const mapDispatchToProps = { updateCart }

export default connect(mapStateToProps, mapDispatchToProps)(ProductMatrix)
